// import { useTranslation } from 'i18next';
// '@mui
//import { enUS, faIR } from '@mui/material/locale';
import { enUS, faIR } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'English',
    value: 'en',
    icon: '/icons/ic_flag_en.svg',
    systemValue: enUS,
    dir: 'ltr',
    selected: false,
  },
  {
    label: 'فارسی',
    value: 'fa',
    icon: '/icons/ic_Iran.webp',
    systemValue: faIR,
    dir: 'rtl',
    selected: false,
  },
];

export default function useLocales() {
  const { t: translate } = useTranslation();
  const langStorage = localStorage?.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];

  const handleChangeLanguage = (newlang) => i18n.changeLanguage(newlang);

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    local: currentLang.systemValue,
    isRTL: () => currentLang.dir === 'rtl',
    allLang: LANGS,
  };
}
